<template>
  <div class="min-h-screen relative overflow-hidden bg-white">
    <!-- <Transition name="fade-slide"> -->
    <!-- Background Blur Effects -->
    <!-- <div v-if="showContent" class="absolute inset-0 pointer-events-none -z-[100]">
        <div class="absolute -bottom-20 left-0 w-screen h-3/4 bg-gradient-to-t from-yellow-200/60 to-transparent mix-blend-multiply filter blur-3xl"></div>
        <div class="absolute -top-20 right-0 w-80 h-1/2 bg-gradient-to-t from-yellow-200/60 to-transparent rounded-full mix-blend-multiply filter blur-3xl"></div>
      </div> -->
    <!-- </Transition> -->
    <!-- Main Content -->
    <div class="min-h-screen flex items-stretch z-10">
      <!-- Left Column - Form -->
      <div class="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div class="w-full max-w-[480px]">
          <!-- Logo/Brand -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-16 text-left flex flex-row items-center justify-between gap-4 self-start">
              <div class="flex justify-center items-center border border-dark rounded-full p-4 w-fit cursor-pointer">
                <img src="/images/CargoLink.svg" alt="CargoLink" class="h-6 w-auto" />
              </div>
            </div>
          </Transition>

          <!-- Header Section -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-6 text-center fade-slide-2">
              <h2 class="text-[32px] font-normal text-dark mb-2">Welcome Back</h2>
              <p class="text-gray-500">{{ loginMode === "email" ? "Enter your credentials to access your account" : "Enter your phone number to continue" }}</p>
            </div>
          </Transition>

          <!-- Create Account Prompt -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-6 fade-slide-2">
              <div class="bg-gradient-to-r from-green-500/5 to-green-500/10 rounded-xl p-4 border border-green-500/10">
                <div class="flex items-center justify-between gap-4">
                  <div class="flex items-center gap-3">
                    <div class="flex-shrink-0 w-10 h-10 rounded-full bg-dark flex items-center justify-center">
                      <Icon name="ph:user-plus" class="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p class="text-sm font-medium text-dark">New to CargoLink?</p>
                      <p class="text-xs text-gray-600">Join us and start shipping</p>
                    </div>
                  </div>
                  <NuxtLink to="/auth/register" class="flex-shrink-0 px-4 py-2 bg-dark text-white text-sm font-medium rounded-lg hover:bg-dark/90 transition-all duration-200 hover:scale-105 active:scale-95"> Sign up </NuxtLink>
                </div>
              </div>
            </div>
          </Transition>

          <!-- Login Mode Toggle -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="flex gap-2 mb-6 bg-gray-100 p-1 rounded-xl">
              <button @click="switchToEmail" type="button" :class="['flex-1 py-2.5 rounded-lg font-medium transition-all', loginMode === 'email' ? 'bg-white text-dark shadow-sm' : 'text-gray-600 hover:text-dark']">
                <Icon name="ph:envelope" class="inline mr-2" size="18" />
                Email
              </button>
              <button @click="switchToOtp" type="button" :class="['flex-1 py-2.5 rounded-lg font-medium transition-all', loginMode === 'otp' ? 'bg-white text-dark shadow-sm' : 'text-gray-600 hover:text-dark']">
                <Icon name="ph:device-mobile" class="inline mr-2" size="18" />
                Phone
              </button>
            </div>
          </Transition>

          <!-- Email Login Form -->
          <Transition name="fade-slide" mode="out-in">
            <form v-if="loginMode === 'email'" @submit.prevent="handleLogin" class="space-y-6 self-center" key="email-form">
              <!-- Email -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">Email address</label>
                <div class="relative">
                  <Icon name="ph:envelope" class="absolute left-4 top-1/2 -translate-y-1/2" :class="[form.email ? (errors.email ? 'text-red-500' : 'text-green-500') : 'text-gray-500']" />
                  <input
                    type="email"
                    v-model="form.email"
                    placeholder="name@company.com"
                    class="w-full pl-11 pr-4 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                    :class="[
                      form.email ? (errors.email ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500' : 'border-green-500 focus:ring-green-500/20 focus:border-green-500') : 'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary',
                    ]"
                    @input="validateField('email')"
                    required />
                  <Icon v-if="form.email && !errors.email" name="ph:check-circle-fill" class="absolute right-4 top-1/2 -translate-y-1/2 text-green-500 w-5 h-5" />
                </div>
                <p v-if="errors.email" class="mt-1 text-sm text-red-500">{{ errors.email }}</p>
                <p v-else-if="form.email && !errors.email" class="mt-1 text-sm text-green-500">Email is valid</p>
              </div>

              <!-- Password -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">Password</label>
                <div class="relative">
                  <Icon name="ph:lock" class="absolute left-4 top-1/2 -translate-y-1/2" :class="[form.password ? (errors.password ? 'text-red-500' : 'text-green-500') : 'text-gray-500']" />
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="form.password"
                    placeholder="••••••••"
                    class="w-full pl-11 pr-11 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                    :class="[
                      form.password ? (errors.password ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500' : 'border-green-500 focus:ring-green-500/20 focus:border-green-500') : 'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary',
                    ]"
                    @input="validateField('password')"
                    required />
                  <button type="button" @click="showPassword = !showPassword" class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    <Icon v-if="showPassword" name="ph:eye-slash" class="w-5 h-5" />
                    <Icon v-else name="ph:eye" class="w-5 h-5" />
                  </button>
                  <Icon v-if="form.password && !errors.password" name="ph:check-circle-fill" class="absolute right-12 top-1/2 -translate-y-1/2 text-green-500 w-5 h-5" />
                </div>
                <p v-if="errors.password" class="mt-1 text-sm text-red-500">{{ errors.password }}</p>
                <p v-else-if="form.password && !errors.password" class="mt-1 text-sm text-green-500">Password is valid</p>
              </div>

              <!-- Remember Me & Forgot Password -->
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <input type="checkbox" id="remember" v-model="form.rememberMe" class="rounded border-[#E8ECEF] text-dark focus:ring-dark/20 focus:outline-none" />
                  <label for="remember" class="text-sm text-gray-600 ml-2">Remember me</label>
                </div>
                <NuxtLink to="/auth/forgot-password" class="text-sm text-dark font-medium hover:text-dark/80 transition-colors underline">Forgot password?</NuxtLink>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                class="w-full bg-dark text-white rounded-xl py-[14px] font-medium hover:bg-dark/90 transition-colors focus:outline-none focus:ring-2 focus:ring-dark/20 disabled:opacity-70 disabled:cursor-not-allowed"
                :disabled="isLoading || !isFormValid">
                <span class="flex items-center justify-center">
                  <Icon v-if="isLoading" name="svg-spinners:180-ring" class="mr-2 h-5 w-5" />
                  {{ isLoading ? "Signing in..." : "Sign in" }}
                </span>
              </button>

              <!-- Error message -->
              <div v-if="loginError" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl" role="alert">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <Icon name="ph:warning-circle" class="h-5 w-5 text-red-400" />
                  </div>
                  <div class="ml-3">
                    <p class="text-sm">{{ loginError }}</p>
                  </div>
                </div>
              </div>

              <!-- Terms -->
              <div class="text-center">
                <div class="flex items-center justify-center">
                  <span class="px-2 text-gray-500 text-xs text-center"
                    >By signing in, you agree to our <NuxtLink to="/terms" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Terms of Service</NuxtLink> and
                    <NuxtLink to="/privacy" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Privacy Policy</NuxtLink></span
                  >
                </div>
              </div>
            </form>
          </Transition>

          <!-- OTP Login Form -->
          <Transition name="fade-slide" mode="out-in">
            <div v-if="loginMode === 'otp'" class="space-y-6" key="otp-form">
              <!-- Step 1: Enter Phone -->
              <div v-if="otpStep === 'phone'">
                <label class="text-sm font-medium text-dark mb-2 block"> Phone Number </label>
                <div class="flex gap-2 items-center">
                  <div class="w-[120px]">
                    <CustomSelect v-model="otpForm.countryCode" :options="countryOptions" :disabled="isLoadingCountries" placeholder="Code" :modelValue="selectedOtpCountryOption?.code" @update:modelValue="(val) => (otpForm.countryCode = val)">
                      <template #option="{ option }">
                        <div class="flex items-center">
                          <img :src="option.flag" class="w-5 h-4 object-cover mr-2" :alt="option.name" />
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                      <template #prefix>
                        <img v-if="selectedOtpCountryOption" :src="selectedOtpCountryOption.flag" class="w-5 h-4 object-cover" :alt="selectedOtpCountryOption.name" />
                      </template>
                      <template #selected="{ option }">
                        <span>{{ selectedOtpCountryOption?.code || option?.code || "Select" }}</span>
                      </template>
                    </CustomSelect>
                  </div>
                  <div class="relative flex-1">
                    <Icon name="ph:device-mobile" class="absolute left-4 top-1/2 -translate-y-1/2" :class="[otpForm.phone ? (errors.otpPhone ? 'text-red-500' : isValidOtpPhone ? 'text-green-500' : 'text-gray-500') : 'text-gray-500']" />
                    <input
                      type="tel"
                      v-model="otpForm.phone"
                      placeholder="7** *** ***"
                      class="w-full pl-11 pr-11 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                      :class="[
                        otpForm.phone
                          ? errors.otpPhone
                            ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500'
                            : isValidOtpPhone
                            ? 'border-green-500 focus:ring-green-500/20 focus:border-green-500'
                            : 'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary'
                          : 'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary',
                      ]"
                      @input="validateField('otpPhone')"
                      @keypress.enter="requestOtp" />
                    <Icon v-if="otpForm.phone && isValidOtpPhone && !errors.otpPhone" name="ph:check-circle-fill" class="absolute right-4 top-1/2 -translate-y-1/2 text-green-500 w-5 h-5" />
                  </div>
                </div>
                <p v-if="errors.otpPhone" class="mt-1 text-sm text-red-500">{{ errors.otpPhone }}</p>
                <p v-else-if="otpForm.phone && isValidOtpPhone" class="mt-1 text-sm text-green-500">Phone number is valid</p>
                <p v-else class="mt-2 text-sm text-gray-500">We'll send a 6-digit verification code to this number</p>

                <button
                  @click="requestOtp"
                  type="button"
                  :disabled="isLoading || !otpForm.phone || !isValidOtpPhone"
                  class="mt-6 w-full bg-dark text-white rounded-xl py-[14px] font-medium hover:bg-dark/90 transition-colors focus:outline-none focus:ring-2 focus:ring-dark/20 disabled:opacity-70 disabled:cursor-not-allowed">
                  <span class="flex items-center justify-center">
                    <Icon v-if="isLoading" name="svg-spinners:180-ring" class="mr-2 h-5 w-5" />
                    {{ isLoading ? "Sending..." : "Send Verification Code" }}
                  </span>
                </button>
              </div>

              <!-- Step 2: Verify OTP -->
              <div v-if="otpStep === 'verify'" class="text-center">
                <div class="mb-6">
                  <h3 class="text-lg font-semibold text-dark mb-2">Enter Verification Code</h3>
                  <p class="text-sm text-gray-600">
                    We sent a 6-digit code to<br />
                    <span class="font-medium text-dark">{{ otpForm.countryCode }} {{ otpForm.phone }}</span>
                  </p>
                </div>

                <OtpInput v-model="otpForm.code" :length="6" @complete="verifyOtpLogin" class="mb-6" />
                <p v-if="errors.otpCode" class="mt-1 text-sm text-red-500">{{ errors.otpCode }}</p>

                <!-- Verify Button -->
                <button
                  @click="verifyOtpLogin(otpForm.code)"
                  type="button"
                  :disabled="isLoading || otpForm.code.length !== 6"
                  class="w-full bg-dark text-white rounded-xl py-[14px] font-medium hover:bg-dark/90 transition-colors focus:outline-none focus:ring-2 focus:ring-dark/20 disabled:opacity-70 disabled:cursor-not-allowed mb-6">
                  <span class="flex items-center justify-center">
                    <Icon v-if="isLoading" name="svg-spinners:180-ring" class="mr-2 h-5 w-5" />
                    {{ isLoading ? "Verifying..." : "Verify Code" }}
                  </span>
                </button>

                <div class="flex items-center justify-center gap-2 text-sm mb-6">
                  <span class="text-gray-600">Didn't receive code?</span>
                  <button v-if="otpCountdown > 0" type="button" disabled class="text-gray-400 cursor-not-allowed">Resend in {{ otpCountdown }}s</button>
                  <button v-else @click="resendOtp" type="button" :disabled="isLoading" class="text-dark font-medium hover:underline disabled:opacity-50">Resend Code</button>
                </div>

                <button
                  @click="
                    () => {
                      otpStep = 'phone'
                      otpForm.code = ''
                      errors.otpCode = ''
                    }
                  "
                  type="button"
                  class="text-sm text-gray-600 hover:text-dark transition-colors mb-6">
                  <Icon name="ph:arrow-left" class="inline mr-1" />
                  Change phone number
                </button>
              </div>

              <!-- Terms -->
              <div class="text-center">
                <div class="flex items-center justify-center">
                  <span class="px-2 text-gray-500 text-xs text-center"
                    >By signing in, you agree to our <NuxtLink to="/terms" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Terms of Service</NuxtLink> and
                    <NuxtLink to="/privacy" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Privacy Policy</NuxtLink></span
                  >
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>

      <!-- Right Column - Image -->
      <div class="hidden lg:flex w-1/2 relative p-12">
        <div class="relative w-full max-w-4xl mx-auto aspect-[4/3]">
          <Transition name="fade-slide">
            <img v-if="showContent" src="/images/auth/LoginImage.png" alt="Large truck on the getting loaded" class="w-full h-full object-cover rounded-[40px]" />
          </Transition>
          <!-- Overlay -->
          <!-- <div class="absolute inset-0 bg-gradient-to-t from-yellow-900/30 to-transparent rounded-[40px]"></div> -->

          <!-- Floating Cards -->
          <Transition name="fade-slide" @after-enter="startFloating">
            <div v-if="showContent" class="absolute inset-0 p-8 fade-slide-4" :style="floatingStyle">
              <!-- Top Stacked Cards -->
              <div class="relative ml-8 mt-8">
                <!-- First Card -->
                <div class="bg-yellow-200/80 backdrop-blur-md p-4 rounded-2xl mb-4 absolute top-0 left-0 w-[280px] z-20">
                  <div class="flex flex-row justify-between">
                    <h3 class="text-sm font-semibold text-dark/80 mb-1">Welcome Back</h3>
                    <div class="rounded-full bg-dark/80 w-2 h-2"></div>
                  </div>
                  <p class="text-xs text-gray-600">Access your CargoLink dashboard and manage your shipments</p>
                </div>
                <!-- Second Card -->
                <div class="bg-dark/80 backdrop-blur-md p-4 rounded-2xl mb-4 absolute top-[50px] left-[50px] w-[280px] z-10">
                  <div class="flex flex-row justify-between">
                    <h3 class="text-sm font-semibold text-gray-100 mb-1">Track & Manage</h3>
                    <div class="rounded-full bg-yellow-200/80 w-2 h-2"></div>
                  </div>
                  <p class="text-xs text-gray-100">Monitor your cargo deliveries and driver locations in real-time</p>
                </div>
              </div>

              <!-- Center Login-style Card -->
              <div class="absolute top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px]">
                <div class="bg-dark/20 backdrop-blur-sm p-4 rounded-3xl">
                  <!-- Login Header -->
                  <div class="flex items-center justify-between mb-4">
                    <div class="flex flex-row items-center justify-between w-full">
                      <h3 class="text-sm font-semibold text-white">Quick Access</h3>
                      <p class="text-xs text-white">24/7 Available</p>
                    </div>
                  </div>
                  <!-- Login Content -->
                  <div class="space-y-3">
                    <div class="flex items-center space-x-3">
                      <div class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                        <Icon name="ph:envelope" class="w-4 h-4 text-white" />
                      </div>
                      <div class="flex-1">
                        <div class="h-2 bg-white/30 rounded w-full mb-1"></div>
                        <div class="h-1 bg-white/20 rounded w-3/4"></div>
                      </div>
                    </div>
                    <div class="flex items-center space-x-3">
                      <div class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                        <Icon name="ph:lock" class="w-4 h-4 text-white" />
                      </div>
                      <div class="flex-1">
                        <div class="h-2 bg-white/30 rounded w-full mb-1"></div>
                        <div class="h-1 bg-white/20 rounded w-1/2"></div>
                      </div>
                    </div>
                    <div class="flex justify-center mt-4">
                      <div class="w-24 h-8 bg-white/30 rounded-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import OtpInput from "~/components/auth/OtpInput.vue"
import CustomSelect from "~/components/ui/CustomSelect.vue"
import { parsePhoneNumberFromString } from "libphonenumber-js"

definePageMeta({
  layout: "register",
  middleware: "guest",
})

const { $toast } = useNuxtApp()
const router = useRouter()
const authStore = useAuthStore()

// Use the countries composable for OTP
const { countries, isLoading: isLoadingCountries } = useCountries()

// Login mode
const loginMode = ref("email") // 'email' or 'otp'
const otpStep = ref("phone") // 'phone' or 'verify'

// Form state with reactive object
const form = reactive({
  email: "",
  password: "",
  rememberMe: false,
  device_name: navigator?.userAgent,
  grant_type: "cookie",
})

// OTP form state
const otpForm = reactive({
  phone: "",
  countryCode: "+255", // Default to Tanzania
  code: "",
})
const otpCountdown = ref(0)
let otpCountdownInterval = null

// Validation state
const errors = reactive({
  email: "",
  password: "",
  otpPhone: "",
  otpCode: "",
})

// UI state
const showPassword = ref(false)
const isLoading = ref(false)
const loginError = ref("")
const showContent = ref(false)

// Computed property to check if form is valid
const isFormValid = computed(() => {
  return form.email && form.password && !errors.email && !errors.password
})

// Computed properties for OTP country selector
const countryOptions = computed(() => {
  if (!countries.value?.length) return []
  return countries.value
})

const selectedOtpCountryOption = computed(() => {
  const selected = countryOptions.value.find((option) => option.code === otpForm.countryCode)
  return selected || null
})

// Validate OTP phone
const isValidOtpPhone = computed(() => {
  if (!otpForm.phone) return false

  try {
    const fullPhone = otpForm.countryCode + otpForm.phone.replace(/\s/g, "")
    const phoneNumber = parsePhoneNumberFromString(fullPhone)
    return phoneNumber ? phoneNumber.isValid() : false
  } catch {
    return false
  }
})

// Validation rules
const validateEmail = (email) => {
  if (!email) return "Email address is required"
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) return "Please enter a valid email address"
  return ""
}

const validatePassword = (password) => {
  if (!password) return "Password is required"
  return ""
}

const validateOtpPhone = (phone) => {
  if (!phone) return "Phone number is required"
  if (!isValidOtpPhone.value) return "Please enter a valid phone number"
  return ""
}

// Validate a specific field
const validateField = (fieldName) => {
  if (fieldName === "email") {
    errors.email = validateEmail(form.email)
  } else if (fieldName === "password") {
    errors.password = validatePassword(form.password)
  } else if (fieldName === "otpPhone") {
    errors.otpPhone = validateOtpPhone(otpForm.phone)
  }
}

// Validate all fields
const validateForm = () => {
  errors.email = validateEmail(form.email)
  errors.password = validatePassword(form.password)
  return !errors.email && !errors.password
}

// Handle login submission
const handleLogin = async () => {
  // Reset previous error
  loginError.value = ""

  // Validate form
  if (!validateForm()) return

  // Show loading state
  isLoading.value = true

  try {
    const result = await authStore.login({
      email: form.email,
      password: form.password,
      device_name: form.device_name,
      grant_type: form.grant_type,
    })

    if (result.success) {
      $toast.success("Login successful")
      // Handle redirection based on user role and status
      const user = result.user
      const userStatus = user?.status
      const restrictedStatuses = ["suspended", "rejected", "deactivated", "in_review", "inreview"]

      // Check if user has restricted status
      if (restrictedStatuses.includes(userStatus)) {
        await navigateTo("/account-restricted")
        return
      }

      // Normal redirect based on role
      switch (user.role) {
        case "shipper":
          await navigateTo("/shipper")
          break
        case "carrier":
          await navigateTo("/carrier")
          break
        case "driver":
          await navigateTo("/driver")
          break
        case "forwarder":
          await navigateTo("/forwarder")
          break
        case "warehouse_operator":
          await navigateTo("/warehouse-operator")
          break
        case "mover_company":
        case "mover":
          await navigateTo("/mover")
          break
        case "admin":
          await navigateTo("/admin")
          break
        default:
          await navigateTo("/dashboard")
      }
    } else {
      loginError.value = result.error
      $toast.error(result.error)
      // Check if email verification is required
      if (result.requires_verification) {
        await navigateTo("/auth/verify?email=" + form.email)
      }
    }
  } catch (error) {
    $toast.error("An unexpected error occurred. Please try again.")
    loginError.value = "An unexpected error occurred. Please try again."
  } finally {
    isLoading.value = false
  }
}

// OTP Login Methods
const switchToOtp = () => {
  loginMode.value = "otp"
  otpStep.value = "phone"
  loginError.value = ""
  errors.email = ""
  errors.password = ""
}

const switchToEmail = () => {
  loginMode.value = "email"
  otpForm.phone = ""
  otpForm.code = ""
  loginError.value = ""
  errors.otpPhone = ""
  errors.otpCode = ""
}

const requestOtp = async () => {
  // Reset errors
  errors.otpPhone = ""
  errors.otpCode = ""

  // Validate phone
  errors.otpPhone = validateOtpPhone(otpForm.phone)
  if (errors.otpPhone) {
    return
  }

  isLoading.value = true
  loginError.value = ""

  try {
    // Combine country code and phone number
    const fullPhone = otpForm.countryCode + otpForm.phone.replace(/\s/g, "")

    const response = await authStore.getAxios().post("/api/v1/auth/otp/request", {
      phone: fullPhone,
      purpose: "login",
    })

    if (response.data.success) {
      otpStep.value = "verify"
      startOtpCountdown(60)
      $toast.success("Verification code sent to your phone")
    }
  } catch (error) {
    errors.otpPhone = error.response?.data?.message || "Failed to send verification code"
  } finally {
    isLoading.value = false
  }
}

const verifyOtpLogin = async (code) => {
  if (!code || code.length !== 6) return

  isLoading.value = true
  loginError.value = ""
  errors.otpCode = ""

  try {
    // Combine country code and phone number
    const fullPhone = otpForm.countryCode + otpForm.phone.replace(/\s/g, "")

    const response = await authStore.getAxios().post("/api/v1/auth/otp/verify", {
      phone: fullPhone,
      otp_code: code,
      grant_type: "cookie",
      device_name: navigator?.userAgent,
    })

    if (response.data.success) {
      const { user } = response.data
      authStore.setAuthData({ user })

      $toast.success("Login successful!")

      // Check if user has restricted status
      const userStatus = user?.status
      const restrictedStatuses = ["suspended", "rejected", "deactivated", "in_review", "inreview"]

      if (restrictedStatuses.includes(userStatus)) {
        await navigateTo("/account-restricted")
        return
      }

      // Redirect based on role
      const redirectPath =
        {
          shipper: "/shipper",
          carrier: "/carrier",
          driver: "/driver",
          forwarder: "/forwarder",
          warehouse_operator: "/warehouse-operator",
          mover_company: "/mover",
          mover: "/mover",
          admin: "/admin",
        }[user.role] || "/shipper"

      await navigateTo(redirectPath)
    }
  } catch (error) {
    errors.otpCode = error.response?.data?.message || "Invalid verification code"
    otpForm.code = ""
  } finally {
    isLoading.value = false
  }
}

const resendOtp = async () => {
  if (otpCountdown.value > 0) return
  await requestOtp()
}

const startOtpCountdown = (seconds) => {
  otpCountdown.value = seconds
  if (otpCountdownInterval) clearInterval(otpCountdownInterval)

  otpCountdownInterval = setInterval(() => {
    otpCountdown.value--
    if (otpCountdown.value <= 0) {
      clearInterval(otpCountdownInterval)
    }
  }, 1000)
}

// Floating animation logic
const floatingEnabled = ref(false)
const mouseX = ref(0)
const mouseY = ref(0)

const startFloating = () => {
  floatingEnabled.value = true
}

const handleMouseMove = (e) => {
  const { innerWidth, innerHeight } = window
  // Center the mouse coordinates to (0, 0) in the middle of the page
  mouseX.value = (e.clientX - innerWidth / 2) / (innerWidth / 2)
  mouseY.value = (e.clientY - innerHeight / 2) / (innerHeight / 2)
}

const floatingStyle = computed(() => {
  if (!floatingEnabled.value) {
    return {} // No transform before transition ends
  }

  const maxMovement = 10 // pixels
  const x = -mouseX.value * maxMovement
  const y = -mouseY.value * maxMovement

  return {
    transform: `translate3d(${x}px, ${y}px, 0)`,
    transition: "transform 0.2s ease-out",
  }
})

// Show content with animation on mount
onMounted(() => {
  window.addEventListener("mousemove", handleMouseMove)
  showContent.value = true
})

onBeforeUnmount(() => {
  if (otpCountdownInterval) clearInterval(otpCountdownInterval)
})

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMouseMove)
})
</script>

<style scoped>
/* Smooth fade transition for login mode switching */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
